
import { Component, computed } from '@angular/core';
import { AbstractLegend } from '@jeppesen-foreflight/jmkw-toolkit';

@Component({
  selector: 'test-core-air-temperature-legend',
  templateUrl: './air-temperature-legend.component.html',
  styleUrls: ['./air-temperature-legend.component.scss'],
  standalone: true,
  imports: []
})
export class AirTemperatureLegendComponent extends AbstractLegend {
  selectedScale = computed(() =>
    this.toolkitApiService.getUnitConfig().temperature === 'FAHRENHEIT'
      ? 'F'
      : 'C'
  );

  scaleValues = computed(() =>
    this.toolkitApiService.getUnitConfig().temperature === 'FAHRENHEIT'
      ? [-40, -4, 32, 68, 104]
      : [-40, -20, 0, 20, 40]
  );
}
